import { render } from "./SupervisorManagement.vue?vue&type=template&id=180fb0c4"
import script from "./SupervisorManagement.vue?vue&type=script&lang=js"
export * from "./SupervisorManagement.vue?vue&type=script&lang=js"

import "./SupervisorManagement.vue?vue&type=style&index=0&id=180fb0c4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__